import {memo} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {RootState} from '../../../../../store/redux';

import CustomBadge from '../../../../../components/mazraeKit/customBadge';
import {addOptionalFormData} from '../../../../../store/redux/advertisementRegisteration';

const AdditionalInfo = () => {
  const dispatch = useDispatch();

  const {input_group, optionalFormData} = useSelector(
    (state: RootState) => state.advertisementRegisteration,
  );

  const sampleFunc = (str: string) => {
    const myobject = str ? JSON.parse(str) : {};

    const keysarr = Object.keys(myobject);

    const selectedItems = keysarr.map(item => {
      const typeofmyobj = typeof myobject[item];

      if (typeofmyobj === 'string') {
        if (myobject[item].indexOf(',') > -1) {
          const newarr = myobject[item].split(',');

          return newarr.map((newarritem: string) => {
            return {title: newarritem, value: item};
          });
        } else {
          return {title: myobject[item], value: item};
        }
      }
      const value = myobject?.[item];

      if (value && typeof value === 'object' && 'title' in value) {
        return {title: value?.title, value: item};
      }
    });

    return selectedItems;
  };

  const closeHandler = (deleteItem: {title: string; value: string}) => {
    const myobjectins = optionalFormData
      ? {...JSON.parse(optionalFormData)}
      : {};

    if (typeof myobjectins[deleteItem.value] === 'string') {
      if (myobjectins[deleteItem.value].indexOf(',') > -1) {
        const newArr = myobjectins[deleteItem.value].split(',');

        myobjectins[deleteItem.value] = newArr
          .filter((item: string) => item !== deleteItem.title)
          .toString();
      } else {
        delete myobjectins[deleteItem.value];
      }
    } else {
      delete myobjectins[deleteItem.value];
    }

    dispatch(addOptionalFormData(JSON.stringify(myobjectins)));
  };

  return (
    <div className="flex flex-wrap gap-2 mt-3 w-100">
      {optionalFormData &&
        sampleFunc(optionalFormData)
          .filter(Boolean)
          .flat(2)
          .filter(item => item?.title)
          .map((item, index) => (
            <div className="flex gap-1" key={index}>
              <CustomBadge
                title={item.title}
                onRemoveItem={() => closeHandler(item)}
              />
            </div>
          ))}
    </div>
  );
};

export default memo(AdditionalInfo);
